<template>
  <div
    :class="classModifiers"
    @click="onContractClick"
    @mouseover="onMouseOver"
    @mouseleave="onMouseLeave"
  >
    <div class="market-contract-horizontal-sushi-common-betslip__header">
      <div
        class="market-contract-horizontal-sushi-common-betslip__image-title"
        :class="{
          'market-contract-horizontal-sushi-common-betslip__image-title--disabled-desktop-market-page':
            isLayoutDesktop && isMarketDisabled && !forCmsWidget && !dashboardMode,
        }"
      >
        <div
          v-if="!isCondensedMobileLayout"
          class="market-contract-horizontal-sushi-common-betslip__image"
          :style="contractImageStyleModifiers"
        >
          <div v-if="showSharesBar" :class="sharesOwnedStyleModifiers"></div>
        </div>
        <div class="market-contract-horizontal-sushi-common-betslip__title">
          <div class="market-contract-horizontal-sushi-common-betslip__title-text">
            {{ title }}
          </div>
        </div>
        <div
          v-if="isLayoutDesktop || (isLayoutMobile && (!isMarketDisabled || forCmsWidget))"
          class="market-contract-horizontal-sushi-common-betslip__last-trade"
        >
          <div
            v-if="showNoPriceHintTitle"
            class="market-contract-horizontal-sushi-common-betslip__last-trade-price-title"
          >
            {{ noPriceHintTitle }}
          </div>
          <div
            class="market-contract-horizontal-sushi-common-betslip__last-trade-price"
            :class="{
              'market-contract-horizontal-sushi-common-betslip__last-trade-price--align-right':
                isStandardMobileLayout || isSimplifiedMobileLayout,
            }"
          >
            <template v-if="currentPrice > 0">
              <market-change-price
                v-if="showChangePriceIndicator && isStandardMobileLayout"
                :price="contractModel.changePriceAsCents"
                :lastClosePrice="contractModel.lastClosePrice"
                :symbol="currentPriceSymbol"
              ></market-change-price>
              <animated-number
                class="market-contract-horizontal-sushi-common-betslip__last-trade-price-value"
                :value="currentPrice"
                :symbol="currentPriceSymbol"
              >
              </animated-number>
              <market-change-price
                v-if="showChangePriceIndicator && !isStandardMobileLayout"
                :price="contractModel.changePriceAsCents"
                :lastClosePrice="contractModel.lastClosePrice"
                :symbol="currentPriceSymbol"
              ></market-change-price>
            </template>
            <template v-else>
              <span v-if="forCmsWidget">&nbsp;</span>
              <span class="market-contract-horizontal-sushi-common-betslip__last-trade-price-new"
                >NEW</span
              >
            </template>
          </div>
        </div>
        <div
          v-if="isLayoutMobile && isMarketDisabled && !forCmsWidget"
          class="market-contract-horizontal-sushi-common-betslip__outcome"
        >
          <market-disabled-outcome-v2
            :market="market"
            :contract="contract"
          ></market-disabled-outcome-v2>
        </div>
      </div>
      <div
        v-if="!hideButtons"
        class="market-contract-horizontal-sushi-common-betslip__ownership-buttons"
        :class="{
          'market-contract-horizontal-sushi-common-betslip__ownership-buttons--disabled':
            isMarketDisabled,
        }"
      >
        <div
          class="market-contract-horizontal-sushi-common-betslip__ownership"
          v-if="showSharesBarBottom || (isLayoutDesktop && isMarketDisabled)"
        >
          &nbsp;
          <!-- intentionally just space -->
        </div>
        <div
          v-else-if="isLayoutMobile && !isCondensedMobileLayout"
          class="market-contract-horizontal-sushi-common-betslip__empty-space"
        ></div>
        <div
          class="market-contract-horizontal-sushi-common-betslip__outcome"
          v-if="isLayoutDesktop && isMarketDisabled"
        >
          <market-disabled-outcome-v2
            :market="market"
            :contract="contract"
          ></market-disabled-outcome-v2>
        </div>
        <div
          class="market-contract-horizontal-sushi-common-betslip__buttons"
          v-if="!isMarketDisabled"
        >
          <!-- Left buttons -->
          <div class="market-contract-horizontal-sushi-common-betslip__buttons--left">
            <!-- User has NO shares -->
            <template v-if="!forCmsWidget && contractModel.mode === VALUES.NO">
              <button
                @click.stop="
                  openPurchaseJourney(
                    contractModel.contractId,
                    BUTTONS.BUY_NO.type,
                    BUTTONS.BUY_NO.value,
                  )
                "
                :class="isButtonActiveClassModifiers(BUTTONS.BUY_NO.id)"
                class="market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-no"
              >
                <button-price
                  class="market-contract-horizontal-sushi-common-betslip__button-price"
                  :price="contractModel.buyNoCostAsCents"
                  :key="contractModel.buyNoCostAsCents"
                  :active="showActiveButtonSecondaryPrice"
                  :win="contractModel.sellYesCostAsCents"
                  text="NO"
                ></button-price>
              </button>
            </template>
            <!-- User has YES shares -->
            <template v-else-if="!forCmsWidget && contractModel.mode === VALUES.YES">
              <button
                @click.stop="
                  openPurchaseJourney(
                    contractModel.contractId,
                    BUTTONS.BUY_YES.type,
                    BUTTONS.BUY_YES.value,
                  )
                "
                :class="isButtonActiveClassModifiers(BUTTONS.BUY_YES.id)"
                class="market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-yes"
              >
                <button-price
                  class="market-contract-horizontal-sushi-common-betslip__button-price"
                  :price="contractModel.buyYesCostAsCents"
                  :key="contractModel.buyYesCostAsCents"
                  :active="showActiveButtonSecondaryPrice"
                  :win="contractModel.sellNoCostAsCents"
                  text="YES"
                ></button-price>
              </button>
            </template>
            <!-- User hasn't any shares -->
            <template v-else>
              <button
                :disabled="forCmsWidget && cmsTradeDisabled"
                :title="
                  forCmsWidget && cmsTradeDisabled ? 'Trading is currently unavailable' : null
                "
                @click.stop="
                  openPurchaseJourney(
                    contractModel.contractId,
                    BUTTONS.BUY_YES.type,
                    BUTTONS.BUY_YES.value,
                  )
                "
                :class="isButtonActiveClassModifiers(BUTTONS.BUY_YES.id)"
                class="market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-yes"
              >
                <button-price
                  class="market-contract-horizontal-sushi-common-betslip__button-price"
                  :price="contractModel.buyYesCostAsCents"
                  :key="contractModel.buyYesCostAsCents"
                  :win="contractModel.sellNoCostAsCents"
                  :active="showActiveButtonSecondaryPrice"
                  text="YES"
                ></button-price>
              </button>
            </template>
          </div>

          <!-- Right buttons -->
          <div class="market-contract-horizontal-sushi-common-betslip__buttons--right">
            <!-- User has NO shares -->
            <template v-if="!forCmsWidget && contractModel.mode === VALUES.NO">
              <button
                @click.stop="
                  !isContractSaleDisabled &&
                  openPurchaseJourney(
                    contractModel.contractId,
                    BUTTONS.SELL_NO.type,
                    BUTTONS.SELL_NO.value,
                  )
                "
                :class="[
                  isButtonActiveClassModifiers(BUTTONS.SELL_NO.id),
                  {
                    'market-contract-horizontal-sushi-common-betslip__button-single--sell-disabled':
                      isContractSaleDisabled,
                  },
                ]"
                :data-tooltip="isContractSaleDisabled ? sellDisabledTooltipText : null"
                class="market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--sell-no"
              >
                <button-price
                  class="market-contract-horizontal-sushi-common-betslip__button-price"
                  :price="contractModel.sellNoCostAsCents"
                  :key="contractModel.sellNoCostAsCents"
                  :active="showActiveButtonSecondaryPrice"
                  text="Sell"
                ></button-price>
              </button>
            </template>
            <!-- User has YES shares -->
            <template v-else-if="!forCmsWidget && contractModel.mode === VALUES.YES">
              <button
                @click.stop="
                  !isContractSaleDisabled &&
                  openPurchaseJourney(
                    contractModel.contractId,
                    BUTTONS.SELL_YES.type,
                    BUTTONS.SELL_YES.value,
                  )
                "
                :class="[
                  isButtonActiveClassModifiers(BUTTONS.SELL_YES.id),
                  {
                    'market-contract-horizontal-sushi-common-betslip__button-single--sell-disabled':
                      isContractSaleDisabled,
                  },
                ]"
                :data-tooltip="isContractSaleDisabled ? sellDisabledTooltipText : null"
                class="market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--sell-yes"
              >
                <button-price
                  class="market-contract-horizontal-sushi-common-betslip__button-price"
                  :price="contractModel.sellYesCostAsCents"
                  :key="contractModel.sellYesCostAsCents"
                  :active="showActiveButtonSecondaryPrice"
                  text="Sell"
                ></button-price>
              </button>
            </template>
            <!-- User hasn't any shares -->
            <template v-else>
              <button
                :disabled="forCmsWidget && cmsTradeDisabled"
                :title="
                  forCmsWidget && cmsTradeDisabled ? 'Trading is currently unavailable' : null
                "
                @click.stop="
                  openPurchaseJourney(
                    contractModel.contractId,
                    BUTTONS.BUY_NO.type,
                    BUTTONS.BUY_NO.value,
                  )
                "
                :class="isButtonActiveClassModifiers(BUTTONS.BUY_NO.id)"
                class="market-contract-horizontal-sushi-common-betslip__button-single market-contract-horizontal-sushi-common-betslip__button-single--buy-no"
              >
                <button-price
                  class="market-contract-horizontal-sushi-common-betslip__button-price"
                  :price="contractModel.buyNoCostAsCents"
                  :key="contractModel.buyNoCostAsCents"
                  :win="contractModel.sellYesCostAsCents"
                  :active="showActiveButtonSecondaryPrice"
                  text="NO"
                ></button-price>
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <market-ownership-and-orders-bar
      v-if="showOwnershipAndOrdersSummary"
      class="market-contract-horizontal-sushi-common-betslip__ownership-and-orders"
      :class="{
        'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--condensed':
          isCondensedMobileLayout,
        'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--dashboard':
          dashboardMode,
        'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--disabled-market-mobile':
          isMarketDisabled && !dashboardMode && isLayoutMobile,
        'market-contract-horizontal-sushi-common-betslip__ownership-and-orders--disabled-market-mobile-dashboard':
          isMarketDisabled && dashboardMode && isLayoutMobile,
      }"
      :contract="contract"
      :symbol="currentPriceSymbol"
    ></market-ownership-and-orders-bar>
  </div>
</template>

<script src="./market-contract-horizontal-sushi-common-betslip.js"></script>
<style src="./market-contract-horizontal-sushi-common-betslip.scss" lang="scss"></style>
